type Props = {
  rows: string[]
}

const PersonaCard = ({ rows }: Props) => (
  <div
    style={{
      display: 'flex',
      width: 'fit-content',
      padding: 12,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 8,
      background: '#540037',
      borderRadius: 8,
    }}
  >
    {rows.map((row, i) => (
      <span
        key={i}
        style={{
          color: '#FFF',
          fontSize: '0.75rem',
          fontWeight: 500,
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
        }}
      >
        {row}
      </span>
    ))}
  </div>
)

export default PersonaCard
